const BASE_API_URL = 'https://api-02.iek.ru/catalog/v1';
const CATALOG_ARCHIVE_URL = '/upload/pictures/katalogi/ru_ru/catalog-all-latest.zip';
const CATALOG_PRICELIST_URL = '/products/price/';
const ITK_CATALOG_PRICELIST_URL = '/local/assets/pricelist/Price_ITK.xlsx';
const ITK_CATALOG_ARCHIVE_URL = '/servis-i-podderzhka/katalogi-i-po/images/Catalog_ITK_new.pdf';
declare global {
    interface Window {
        _catalogSettings?: {
            template: string;
            lang: string;
            trademarks: string;
            baseRoute: string;
        };
    }
}

const TEMPLATE = window._catalogSettings?.template || 'new_iek';
const LANG = window._catalogSettings?.lang || 'ru';
const TRADEMARKS = window._catalogSettings?.trademarks || 'IEK';
const BASE_ROUTE = window._catalogSettings?.baseRoute || '/products/catalog';

export {
    BASE_API_URL,
    CATALOG_ARCHIVE_URL,
    CATALOG_PRICELIST_URL,
    ITK_CATALOG_PRICELIST_URL,
    ITK_CATALOG_ARCHIVE_URL,
    TEMPLATE,
    LANG,
    TRADEMARKS,
    BASE_ROUTE,
};
